<template>
  <div class="bg-grey-1 q-pa-lg">
    <q-card>
      <q-card-section>
        <h2 class="text-h6 q-mb-md q-mt-none">
          <q-icon name="fa fa-lock" class="on-left" />
          Connect Your {{ platform.name }} Account
        </h2>
        <div class="text-body1 q-mb-md">
          Click "Get Started" below to login to {{ platform.name }} and import your posts.
        </div>
        <div class="text-center q-mt-lg">
          <slot />
        </div>
      </q-card-section>
    </q-card>
    <instructions :platform="platform.type" class="q-my-xs" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Platform } from '@/social/types';
import Instructions from './Instructions.vue';

export default defineComponent({
  components: {
    Instructions,
  },
  props: {
    platform: {
      type: Object as () => Platform,
      required: true,
    },
  },
});
</script>
